/**
 * UI 상태 관리 Store
 */

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface UIState {
  // Sidebar
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;

  // Modals
  modals: Record<string, boolean>;
  openModal: (modalId: string) => void;
  closeModal: (modalId: string) => void;
  isModalOpen: (modalId: string) => boolean;

  // Theme (향후 다크모드 구현 시 사용)
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
}

export const useUIStore = create<UIState>()(
  devtools(
    persist(
      (set, get) => ({
        // Initial State
        sidebarCollapsed: false,
        modals: {},
        theme: 'light',

        // Sidebar Actions
        toggleSidebar: () => {
          set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed }));
        },

        setSidebarCollapsed: (collapsed: boolean) => {
          set({ sidebarCollapsed: collapsed });
        },

        // Modal Actions
        openModal: (modalId: string) => {
          set((state: UIState) => ({
            modals: { ...state.modals, [modalId]: true },
          }));
        },

        closeModal: (modalId: string) => {
          set((state: UIState) => ({
            modals: { ...state.modals, [modalId]: false },
          }));
        },

        isModalOpen: (modalId: string) => {
          return get().modals[modalId] || false;
        },

        // Theme Actions
        setTheme: (theme: 'light' | 'dark') => {
          set({ theme });
        },
      }),
      {
        name: 'ui-storage', // localStorage key
        partialize: (state: UIState) => ({
          sidebarCollapsed: state.sidebarCollapsed,
          theme: state.theme,
        }),
      }
    ),
    { name: 'UIStore' }
  )
);
